export default {
  namespaced: true,

  state: () => ({
    isShown: false,
    openedFromMenu: null,
  }),

  mutations: {
    setShow: (state, { isShown, openedFromMenu }) => {
      state.isShown = isShown;
      if (typeof openedFromMenu === 'string') {
        state.openedFromMenu = openedFromMenu;
      }
    },
  },

  actions: {
    show({ commit }, { openedFromMenu }) {
      commit('setShow', { isShown: true, openedFromMenu });
    },
    hide({ commit }) {
      commit('setShow', { isShown: false });
    },
  },
};
